module.exports = __webpack_public_path__ + "static/media/20170806_50day_2426AT.7acd0eb2.jpg";